import { render, staticRenderFns } from "./productstest.vue?vue&type=template&id=551b8050&"
import script from "./productstest.vue?vue&type=script&lang=js&"
export * from "./productstest.vue?vue&type=script&lang=js&"
import style0 from "./productstest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports